/**
 *
 * FileRow
 *
 */
import React, { memo, useState, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// antd component
import { Form, Input } from 'antd';

// icons
import CustomIcons from 'components/CustomIcons';

// components
import ErrorBoundary from 'engine/ErrorBoundary';

// Communication components
import {
  FBPreviewFile
} from 'components/Communications';


function FileRow({
  element,
  nameRow,
  rowsValues,
  onRemove,
  // default props
  className,
  ...rest
}) {
  const childClassNames = classNames('tcf-fb-field-row', className);
  const { key, name, fieldKey, ...restField } = element;
  const [rowValue, setRowValue] = useState({});

  useEffect(() => {
    setRowValue(prev => ({
      ...prev,
      ...rowsValues[name]
    }))
  }, [rowsValues]);

  const rowFileName = useMemo(() => (
    <Form.Item
      {...restField}
      name={[name, 'file-name']}
      fieldKey={[fieldKey, 'file-name']}
      rules={[
        {
          required: true,
          message: 'Champ obligatoire',
        },
      ]}
      label={`Titre du document #${Number(name) + 1}`}
      className="file-name"
    >
      <Input placeholder={`File Name ${name}`} />
    </Form.Item>
  ), [name, fieldKey, restField]);

  const rowFileUrl = useMemo(() => !!rowValue && (
    <Form.Item
      {...restField}
      name={[name, 'file-url']}
      fieldKey={[fieldKey, 'file-url']}
      rules={[
        {
          required: true,
          message: 'Champ obligatoire',
        },
      ]}
      className="file-url"
    >
      <FBPreviewFile
        showTitle={false}
        file={rowValue[`file-url`]}
        name={[name, 'file-url']}
        showInput={false}
        showIcon={false}
        showIconPreview={false}
      />
    </Form.Item>
  ), [name, fieldKey, restField, rowValue]);

  const rowFileActions = useMemo(() => (
    <CustomIcons className="dynamic-delete-button" type="garbage" onClick={() => onRemove(name)} />
  ), [name, onRemove]);

  return element && (
    <div className={childClassNames}>
      <ErrorBoundary>
        {rowFileName}
        {rowFileUrl}
        {!!onRemove && (rowFileActions)}
      </ErrorBoundary>
    </div>
  );
};

FileRow.defaultProps = {};
FileRow.propTypes = {
  onRemove: PropTypes.func,
};


export default memo(FileRow);